import { render } from "./WidgetComponent.vue?vue&type=template&id=4a2d3c4c&lang=true"
import script from "./WidgetComponent.vue?vue&type=script&lang=js"
export * from "./WidgetComponent.vue?vue&type=script&lang=js"

import "./WidgetComponent.vue?vue&type=style&index=0&id=4a2d3c4c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__